// extracted by mini-css-extract-plugin
export default {"appContent":"App_appContent__1da55"};